<template>
  <div>
    <!-- in the case we have a cancel button defined -->
    <confirm-modal v-if="showCancel"
                   :name="modal_name"
                   :title="title"
                   :message="message"
                   :variant="variant"
                   :width="width"
                   :confirm-text="confirmText"
                   :confirm-icon="confirmIcon"
                   :cancel-text="cancelText" />
    <!-- otherwise just show alert -->
    <alert-modal v-else
                 :name="modal_name"
                 :title="title"
                 :message="message"
                 :variant="variant"
                 :width="width"
                 :confirm-text="confirmText" />
  </div>
</template>

<script>
import AlertModal from 'VueModals/AlertModal';
import ConfirmModal from 'VueModals/ConfirmModal';

export default {
  name: `quick-alert-modal`,
  components: {
    AlertModal,
    ConfirmModal,
  },
  props: {
    scope: {
      type: String,
      required: false,
      default: `global`,
    },
    message: {
      type: String,
      required: false,
      default: ``,
    },
    variant: {
      type: String,
      required: false,
      default: `info`,
    },
    width: {
      type: String,
      required: false,
      default: `500`,
    },
    title: {
      type: String,
      required: false,
      default: `Notice`,
    },
    showCancel: {
      type: Boolean,
      required: false,
      default: false,
    },
    confirmText: {
      type: String,
      required: false,
      default: `Confirm`,
    },
    confirmIcon: {
      type: String,
      required: false,
      default: null,
    },
    cancelText: {
      type: String,
      required: false,
      default: `Cancel`,
    },
  },
  computed: {
    modal_name() {
      return `quick-alert-modal-${this.scope}`;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.header-content) {
  width: 100%;
  justify-content: center;
  display: flex;
}

:deep(.header-controls) {
  position: absolute;
  right: 1em;
}

:deep(.vjs-modal-body) {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
